<script>
import Config from '@/config';
import Size from '@/mixins/size';
import {getActivityList} from '@/api';
import {pageIsFinish} from '@/libs/util';
import {Image, List, PullRefresh} from 'vant';

export default {
  mixins: [
    Size
  ],
  components: {
    [List.name]: List,
    [Image.name]: Image,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      page: 1,
      activities: [],

      loading: false,
      finished: false,
      refreshing: false
    }
  },
  mounted() {
    window.document.title = '速电通-优惠活动';
  },
  methods: {
    refresh() {
      this.page = 1;
      this.finished = false;
      this.loadData();
    },
    loadData() {
      if (this.refreshing) {
        this.activities = [];
        this.refreshing = false;
      }

      this.loading = true;
      getActivityList(this.page, Config.pageSize).then(response => {
        if (response.data.code === Config.successCode) {
          response.data.body.data = response.data.body.data.map(value => {
            value.title = value.title.replace(/<[^>]+>/g, '');
            value.content = value.content.replace(/<[^>]+>/g, '');
            return value;
          });
          this.activities = this.page === 1 ? response.data.body.data : this.activities.concat(response.data.body.data);
          this.finished = pageIsFinish(response.data.body);
          this.page = response.data.body.page + 1;
        }
      }).finally(() => this.loading = false).catch(() => this.finished = true);
    },
    toActivity(item) {
      if (!item.toUrl) {
        return;
      }

      window.location.href = item.toUrl;
    }
  }
}
</script>

<template>
  <van-pull-refresh v-model="refreshing" @refresh="refresh" :style="{height: (height - 64) + 'px'}" id="activities">
    <div class="background"/>
    <van-list v-model="loading" :finished="finished" :finished-text="activities.length === 0 ? '' : '没有更多了'" @load="loadData" :style="{height: (height - 92) + 'px'}" class="activities">
      <div class="item" v-for="(item, index) in activities" :key="index" @click="toActivity(item)">
        <div class="content">
          <div class="title">{{ item.title }}</div>
          <div class="description">{{ item.content }}</div>
        </div>
        <van-image radius="4" width="96" height="64" :src="item.cover"/>
      </div>
    </van-list>
    <div v-if="activities.length === 0" :style="{height: (height - 92) + 'px'}" class="no-data">
      <div class="content">
        <img src="../../assets/images/no-data.png"/>
      </div>
    </div>
  </van-pull-refresh>
</template>

<style scoped>
#activities {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #F6F9F8;
}

#activities .background {
  height: 72px;
  background-color: #009251;
}

#activities .activities {
  top: 18px;
  position: fixed;
  margin: 0 12px;
  overflow-y: auto;
}

#activities .activities .item {
  display: flex;
  padding: 12px;
  border-radius: 8px;
  align-items: center;
  background-color: white;
}

#activities .activities .item + .item {
  margin-top: 12px;
}

#activities .activities .item .content {
  margin-right: 12px;
  width: calc(100% - 96px);
}

#activities .activities .item .content .title {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
}

#activities .activities .item .content .description {
  color: #999999;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
